import React from "react";
import ReactTable from 'react-table-v6'
import Moment from 'moment';
import { Component, Fragment } from "react";

import {
	Card,
	CardBody,
	CardTitle,
	Col,
	Row,
	Progress,
	Input,
	ListGroup,
	ListGroupItem,
	Button,
	ButtonGroup,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
  Form,
  FormGroup,
  Label
} from 'reactstrap';

import update from 'react-addons-update';
import redpin from '../../../assets/images/pins/red_pin.png';
import greenpin from '../../../assets/images/pins/green_pin.png';
import brokenpin from '../../../assets/images/pins/broken_pin.png';
import { Line, Bar } from 'react-chartjs-2';
import Chart from 'react-c3-component';
import 'c3/c3.css';
import 'react-table-v6/react-table.css'
import { authenticationService } from '../../../jwt/_services';

class TrainingMaterialsViewMobile extends React.Component {

	intervalID = 0;

	constructor(props) {
    super(props);

		//const currentUser = authenticationService.currentUserValue;
		//console.log('currentUser info: ' + JSON.stringify(currentUser));
		//console.log('currentUser info: ' + JSON.stringify(currentUser.token));

    this.state = {
			noDevices: false,
			devicesLoaded: false,
			modal: false,
			devices: [],
			trainingMaterials: []
	  };

		// this.toggle4 = this.toggle4.bind(this);
		// this.toggle5 = this.toggle5.bind(this);
		// this.toggle6 = this.toggle6.bind(this);
		// this.handleDateChange = this.handleDateChange.bind(this);

  }

	async componentDidMount() {

    this.getDownloadsData();

		setTimeout(()=>{ this.getDownloadsData(); }, 1000);
	}

	componentWillUnmount() {
		clearInterval(this.intervalID);

	}

	getDownloadsData = async () => {

		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-support-material?MaterialType=2";

    var token = "";

		console.log("laser-usage this.props.authToken: " + JSON.stringify(this.props));

    if (this.props.authToken) {
      console.log("laser-usage this.props.authToken: " + this.props.authToken);
      token = this.props.authToken;
    }

    try {

      const response = await fetch(url, {
  			method: 'GET',
  			headers: {
  				Authorization: token
  			},
  		});

  		const body = await response.json();
  		console.log("all downloads: " + JSON.stringify(body));

  		if (body.status == 'Success') {
  			this.setState({ trainingMaterials: body.results });
  		} else {
        //ADD ERROR MESSAGE
      }

    }
    catch (err) {
      console.log(err);
    }

	};


	render() {
		return (
			<div style={{ fontFamily: "Arial" }}>
				<Row className="ml-1 mt-3 mb-2">
					<Col md="6">
						<h1 style={{color:'#737782'}}>Clinical Videos</h1>
					</Col>
				</Row>
				<Row className="mb-3">
					{this.state.trainingMaterials.map((tm, key) => {
						return (

							<Col sm="12" md="12" lg="6" xl="4">
								<Card className="card-hover">
									<CardBody>
										<Row className="mb-3">
											<Col md="12">
												<h3 style={{color:'#737782'}}>{tm.Title}</h3>
											</Col>
										</Row>
										<Row className="mb-3">
											<Col md="12" className="text-center">
												<div style={{ width: '100%'}}>
													<iframe style={{ height: "300px", width: '100%'}} src={tm.ItemUrl} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" allowFullScreen="allowFullScreen"></iframe>
												</div>
											</Col>
										</Row>
									</CardBody>
								</Card>
							</Col>

							);
					 })}
				</Row>
			</div>
		);
	}
}

export default TrainingMaterialsViewMobile;
